<template>
    <LayoutMinimal>
    <div id="maintenance_mode">
        <article v-if="active">
            <h1>{{$t('maintenance.header')}}</h1>
            <div>
                <p>
                    <a
                        href="#"
                        @click="$router.go()"
                    >
                        {{$t('maintenance.text')}}
                    </a>
                </p>
                <p>{{$t('maintenance.divasplay_team')}}</p>
            </div>
        </article>
    </div>
    </LayoutMinimal>
</template>

<script>
import resources from "../resources";
import LayoutMinimal from "../layouts/LayoutMinimal";
import ErrorWaiter from "../modules/error-waiter/ErrorWaiter";

export default {
    components: {
        LayoutMinimal,
    },
    data(){
        return {
            active: false
        }
    },
    mounted(){
        const waiter = new ErrorWaiter("maintenance_mode", [
            5 * 1000,   // 5 seconds
            15 * 1000,  // 15 seconds
            // 30 * 1000,  // 30 seconds
            // 60 * 1000   // 1 minute
        ]);

        if (waiter.isWaiting) return;

        console.log('maintenance mode', waiter.timeout);

        setTimeout(() => {
            resources.carousel.index({})
                .then((response) => {
                    waiter.stopWaiting();
                    this.$router.push({name: 'home'});
                }).catch(err => {
                    waiter.stopWaiting();
                    this.active = true;
                });
        }, waiter.timeout);
        waiter.try();
    },
}
</script>

<style lang="scss" scoped>
#maintenance_mode{
    font: 20px Helvetica, sans-serif;
    color: #fff;
    background: #000;

    article {
        width: 650px;
        margin: 0 auto;

        h1 {
            font-size: 50px;
        }
        a{
            color: #cccccc;
            text-decoration: underline;
            &:hover{
                color: #a8a8a8;
            }
        }
    }
}
</style>